import React from 'react'
import styled from 'styled-components'
import SkillBar from 'react-skillbars'
import { Link } from 'react-router-dom'

function Skills() {
    const SKILLS = [
        {
        "type": "Front-end",
        "level": 80,
        "color":  {
            "bar": "#c46500",
            "title": {
            "text": "#ece1cb",
            "background": "#ece1cb",
            }
        }
    },
        {
        "type": "ReactJS",
        "level": 65,
        "color":  {
            "bar": "#c46500",
            "title": {
            "text": "#ece1cb",
            "background": "#ece1cb",
            }
        }
    },
        {
        "type": "Back-end",
        "level": 60,
        "color":  {
            "bar": "#c46500",
            "title": {
            "text": "#ece1cb",
            "background": "#ece1cb",
            }
        }
    },
        {
        "type": "Database",
        "level": 45,
        "color":  {
            "bar": "#c46500",
            "title": {
            "text": "#ece1cb",
            "background": "#ece1cb",
            }
        }
    },
        {
        "type": "Python",
        "level": 30,
        "color":  {
            "bar": "#c46500",
            "title": {
            "text": "#ece1cb",
            "background": "#ece1cb",
            }
        }
    },

    ]
    return (
        <ImageSectionStyled>
            <div className="left-content">
                <p className="paragraph">
                Since beginning my journey as web developer, I've done made something with my own skills, creating single page
                Website. Learn UI/UX creating more Website and then share it with the world in my <LinkText to={{pathname: "https://github.com/dhikad19"}} target="_blank" rel="noopener noreferrer">GitHub.</LinkText>
                <br/>
                <br/>
                I successful create responsive Website (Mobile) that are fast, easy to use and built with best practices. 
                The main area of my expertise is Front-End development, HTML, CSS, JavaScript, React, building small web apps
                features, animation and interactive layouts.
                <br/>
                <br/>
                I also had a little experience with Back-End Developer such as (Python, MySQL, NoSQL, MongoDB and others).
                <br/>
                <br/>
                Visit my <LinkText to={{pathname: "https://www.linkedin.com/in/dwiandikaa/"}} target="_blank" rel="noopener noreferrer">LinkedIn</LinkText> profile for more detail or just <LinkText to="/contact">Contact</LinkText> me.
                </p>
                
            </div>
            <div className="content">
            <SkillBar skills={SKILLS} height={30} animationDelay={500} animationDuration={3000} />
            </div>
        </ImageSectionStyled>
    )
}

const LinkText = styled(Link)`
    color: #c46500;
    text-decoration: none;
    text-align: left;
    transition: 0.3s ease-in-out;
    cursor: pointer;
    
    &:hover{
        color: #c43300;
        transition: 0.3s ease-in-out;
    }
`

const ImageSectionStyled = styled.div`
    margin-top: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    @media screen and (max-width:1000px){
        flex-direction: column;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    .ityped-cursor{
        animation: blink 1s infinite;
    }

    @keyframes blink {
        100%{
            opacity: 0;
        }
        50%{
            opacity: 1;
        }
    }
    .left-content{
        width: 100%;

        @media screen and (max-width: 768px){
                width: 100%;
        }
    }

    .content{
        width: 100%;
        padding: 0 1.5rem;

        @media screen and (max-width: 768px){
            padding: 0 1rem;
            }
        }

        .paragraph{
            padding: 1.5rem 0rem;

            @media screen and (max-width: 768px){
                padding: 1.2rem 2rem;
    }
        }
        .about-info{
            display: flex;
            padding-bottom: 1.4rem;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
`;
export default Skills;
